// Loading screen: the coach's code and runtimes for a coach user (coach/warm.ts), right after the sections'
// code. Nothing for anyone else: the step returns at once (it borrows the sections' label, so the screen never
// shows a coach line to a person with the coach off). Only in a build (dev serves modules one by one).
import { store } from '../state/store';
import { defineWarmup } from '../shell/warmup/step';
import { anyRecCoach } from '@valyrio/engine/coach/rec-prefs';
import { coachOnFor } from './coach-on';
import { recCoachFor, recCoachNeedsModel } from './rec/prefs';

export const warmup = defineWarmup({
  id: 'coach',
  order: 310,
  label: 'sections',
  dev: false,
  async run({ progress, appReady }) {
    await appReady;
    // the coach, or a recordings feature that needs the model (coach/rec/prefs.ts; its code warms with it)
    const me = store.get().me;
    if (!coachOnFor(me) && !recCoachNeedsModel(me) && !anyRecCoach(recCoachFor(me))) return;
    const { warmCoach } = await import('./warm');
    await warmCoach(progress);
  },
});
